import { render, staticRenderFns } from "./IadeArizaDetaySepetResim.vue?vue&type=template&id=b9644c6c&"
import script from "./IadeArizaDetaySepetResim.vue?vue&type=script&lang=js&"
export * from "./IadeArizaDetaySepetResim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports